"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigStage = void 0;
var ConfigStage;
(function (ConfigStage) {
    ConfigStage["PROD"] = "PROD";
    ConfigStage["DEVO"] = "DEVO";
})(ConfigStage = exports.ConfigStage || (exports.ConfigStage = {}));
//# sourceMappingURL=config-stage.js.map